export default __webpack_public_path__ + "static/media/tsi_help5.784b1070.png";